var _path;
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.576 14.013L9.334 22.45v9.104a.889.889 0 00.889.889l6.225-.016a.889.889 0 00.884-.89V26.22a.889.889 0 01.889-.889h3.555a.889.889 0 01.889.889v5.313a.889.889 0 00.889.892l6.223.017a.889.889 0 00.888-.89v-9.11l-10.24-8.429a.677.677 0 00-.85 0zm16.178 5.734L21.692 8.166a2.666 2.666 0 00-3.388 0L4.242 19.746a.666.666 0 00-.089.94l1.417 1.721a.666.666 0 00.939.091l13.067-10.763a.677.677 0 01.85 0l13.067 10.763a.667.667 0 00.939-.089l1.416-1.722a.664.664 0 00-.094-.94z"
  })));
}
export default SvgHome;